/* =====================================================================
   AIRFORCE · Shopify data bridge (runs after af-data.js, before af-core.js)
   Merges what the store knows (window.AF_SHOP, written by theme.liquid)
   into AF_DATA: prices, product links, photos, dyno runs, fitment, gallery,
   contact details and section switches. Anything not set in Shopify keeps
   the default from af-data.js.
   ===================================================================== */
(function () {
  "use strict";
  var D = window.AF_DATA, S = window.AF_SHOP, C = window.AF_CURVES;
  if (!D || !S) return;
  var P = S.products || {}, ST = S.settings || {};
  var money = function (cents) { return cents == null ? null : Math.round(cents) / 100; };
  /* first variant that can be bought, else the first one */
  var first = function (p) { if (!p || !p.variants || !p.variants.length) return null; return p.variants.filter(function (v) { return v.available; })[0] || p.variants[0]; };
  /* stock: "in", "backorder" (out of stock, still selling) or "soldout" (can't be bought). Lead time: the product's
     "Lead time" metafield (custom.lead_time), else the theme setting */
  var stockOf = function (pr, v) {
    v = v || first(pr); if (!pr || !v) return null;
    var lead = pr.lead || (S.settings && S.settings.leadTimeDefault) || null;
    return { state: !v.available ? "soldout" : v.qty != null && v.qty <= 0 ? "backorder" : "in", lead: lead };
  };
  window.AF_STOCK_OF = stockOf;

  /* ---------- brand, contact, switches ---------- */
  ["email", "address", "instagramUrl", "facebookUrl", "youtubeUrl"].forEach(function (k) { if (ST[k]) D.brand[k] = ST[k]; });
  if (ST.instagram) D.brand.instagram = ST.instagram;
  if (ST.season) D.settings.season = ST.season;
  if (ST.show) Object.keys(ST.show).forEach(function (k) { D.settings.show[k] = !!ST.show[k]; });
  if (ST.installVideoUrl) D.settings.installVideoUrl = ST.installVideoUrl;
  if (ST.fenderVideoUrl) D.settings.fenderVideoUrl = ST.fenderVideoUrl;
  ["seasonBadge", "stockNote", "returnsPolicy", "tunePipeNote", "fuelNote"].forEach(function (k) { if (ST[k]) D.settings[k] = ST[k]; });
  D.settings.storeUrl = location.origin;
  if (ST.ryanPhoto && D.about && D.about.people && D.about.people[0]) { D.about.people[0].img = ST.ryanPhoto; D.about.people[0].imgCaption = null; }

  /* ---------- parts -> linked products (price, photo, link, variant) ---------- */
  var PART_PRODUCT = { stack: "stack_ktm", "rp-pipe": "rp_pipe", tune: "tune", ecu: "ecu", "throttle-body": "throttle_body", cam: "cam", "kit-490": "kit_490",
    "cyl-490": "cyl_490", "piston-490": "piston_490", "head-gasket-490": "head_gasket_490", "base-gasket-490": "base_gasket_490",
    baro: "baro", "switch": "switch", bridge: "bridge", "yz-stack": "stack_yamaha", "yz-rp-pipe": "rp_pipe_yamaha", "yz-tune": "tune", "yz-kit-490": "kit_490_yamaha" };
  window.AF_PART_PRODUCT = PART_PRODUCT;
  D.parts.forEach(function (p) {
    var pr = P[PART_PRODUCT[p.id]], v = first(pr); if (!pr || !v) return;
    p.price = money(v.price); p.href = pr.url; p.shopify = { product: PART_PRODUCT[p.id], variant: v.id }; p.stock = stockOf(pr, v);
    if (pr.image && (ST.useProductPhotos || !p.img)) p.img = pr.image;   /* no built-in photo: use the product's own */
  });

  /* ---------- stack kit (one product per make on the store) ---------- */
  var KIT_PRODUCT = { ktm: "stack_ktm", yamaha: "stack_yamaha", honda: "stack_honda", "beta-sherco": "stack_beta" };
  window.AF_KIT_PRODUCT = KIT_PRODUCT;
  (D.stackKit.variants || []).forEach(function (v) {
    var pr = P[KIT_PRODUCT[v.id]], fv = first(pr); if (!pr || !fv) return;
    v.price = money(fv.price); v.href = pr.url; v.shopify = { product: KIT_PRODUCT[v.id], variant: fv.id }; v.stock = stockOf(pr, fv);
    if (pr.image && (ST.useProductPhotos || !v.img)) v.img = pr.image;
  });
  if (P.outerwear && first(P.outerwear)) { D.outerwear.price = money(first(P.outerwear).price); D.outerwear.stock = stockOf(P.outerwear); if (P.outerwear.image) D.outerwear.img = P.outerwear.image; }
  if (P.fender_ktm && first(P.fender_ktm)) D.fender.price = money(first(P.fender_ktm).price);

  /* ---------- light wiring harness: each option finds its variant by name (every word in `match`), else by SKU ---------- */
  if (D.harness) {
    var HN = P.light_harness, hv = HN && HN.variants || [], norm = function (t) { return String(t || "").toLowerCase().replace(/[^a-z0-9]/g, ""); };
    if (!HN || !hv.length) D.harness.unlinked = true;
    else {
      D.harness.options.forEach(function (o) {
        var v = hv.length === 1 ? hv[0] : hv.filter(function (x) { var t = norm(x.title); return o.match.every(function (w) { return t.indexOf(w) > -1; }); })[0] ||
          hv.filter(function (x) { return x.sku && norm(x.sku) === norm(o.sku); })[0];
        if (v) { o.price = money(v.price); o.shopify = { variant: v.id }; o.stock = stockOf(HN, v); } else o.missing = true;
      });
      if (HN.image) D.harness.img = HN.image;
    }
  }

  /* ---------- homepage shop cards ---------- */
  var CARD = { "Airforce Velocity Stack Kit": "stack_ktm", "Stubby Fender with Light": "fender_ktm", "Airforce Tune": "tune", "AiM ECU": "ecu", "ECU Switch": "switch",
    "ECU Bridge Cable": "bridge", "Replacement Outerwear": "outerwear", "Airforce 490 Cylinder & Piston Kit": "kit_490", "Crower Cam": "cam", "Throttle Body": "throttle_body",
    "Light Wiring Harness + Delay Relay": "light_harness" };
  (D.catalog || []).forEach(function (c) {
    var pr = P[CARD[c.name]], v = first(pr); if (!pr || !v) return;
    c.price = money(v.price); c.stock = stockOf(pr, v); c.href = c.name === "Stubby Fender with Light" && S.urls.fenders ? S.urls.fenders : pr.url;
    if (pr.image && (ST.useProductPhotos || !c.img)) { c.img = pr.image; c.icon = null; }
  });

  /* ---------- dyno runs from Shopify (metaobject dyno_run), if any ---------- */
  if (S.dyno && S.dyno.length) {
    var grid = C.rpm;
    var resample = function (src, key) {
      var r = src.rpm || [], y = src[key] || [];
      return grid.map(function (x) {
        if (!r.length) return 0; if (x <= r[0]) return y[0]; if (x >= r[r.length - 1]) return y[y.length - 1];
        for (var i = 1; i < r.length; i++) if (r[i] >= x) { var t = (x - r[i - 1]) / (r[i] - r[i - 1]); return +(y[i - 1] + t * (y[i] - y[i - 1])).toFixed(2); }
        return y[y.length - 1];
      });
    };
    var runs = [];
    S.dyno.forEach(function (m) {
      if (!m || !m.id) return;
      var curveKey = "shop_" + m.id.replace(/[^a-z0-9]/gi, "_");
      if (m.curve && m.curve.rpm && m.curve.hp && m.curve.tq) C[curveKey] = { hp: resample(m.curve, "hp"), tq: resample(m.curve, "tq") };
      else { var old = (D.dynoRuns.filter(function (r) { return r.id === m.id; })[0] || {}); curveKey = old.curve; }
      if (!curveKey || !C[curveKey]) return;
      runs.push({ id: m.id, name: m.name || m.id, sub: m.sub || "", platform: m.platform || "ktm-450-2016", type: m.type || "measured",
        parts: m.parts || [], dyno: m.dyno || "DYNOmite", correction: m.correction || "Standard", bike: m.bike || "2025 KTM 450", runDate: m.runDate || "",
        peakHp: m.peakHp, peakTq: m.peakTq, gainPct: m.parts && m.parts.length ? { hp: m.gainHp || 0, tq: m.gainTq || 0 } : null, bands: m.bands || null, curve: curveKey, order: m.order || 0 });
    });
    if (runs.length && runs.some(function (r) { return r.id === "stock"; })) {
      runs.sort(function (a, b) { return a.order - b.order; });
      if (C["shop_stock"]) C.stock = C["shop_stock"];
      D.dynoRuns = runs;
    }
  }

  /* ---------- fitment (metaobject fitment_rule), if any ---------- */
  if (S.fitment && S.fitment.length) {
    D.fitment = S.fitment.filter(function (f) { return f.make && f.models && f.models.length && f.variant; }).map(function (f) {
      var b = D.bikes[f.make] = D.bikes[f.make] || {};
      f.models.forEach(function (m) { if (!b[m]) b[m] = [f.yearStart || 2010, f.yearEnd || new Date().getFullYear() + 1]; });
      return { make: f.make, models: f.models, label: f.label || null, yearStart: f.yearStart || 2010, yearEnd: f.yearEnd || null, variant: f.variant };
    });
  }

  /* ---------- gallery (metaobject gallery_item), if any ---------- */
  if (S.gallery && S.gallery.length) {
    var keep = D.gallery.filter(function (g) { return g.tab === "dyno"; });
    D.gallery = S.gallery.filter(function (g) { return g.img; }).map(function (g) {
      return { img: g.img, photo: true, tab: g.tab || "builds", caption: g.caption || "", featured: !!g.featured, product: g.product || null };
    }).concat(keep);
  }
})();
